import { render, staticRenderFns } from "./ChangePhone1.vue?vue&type=template&id=6653d858&scoped=true"
import script from "./ChangePhone1.vue?vue&type=script&lang=js"
export * from "./ChangePhone1.vue?vue&type=script&lang=js"
import style0 from "./ChangePhone1.vue?vue&type=style&index=0&id=6653d858&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6653d858",
  null
  
)

export default component.exports